import {CompetitorSimple} from './competitor';

export class Crew {
  id: number;
  number: number;
  driver: number;
  navigator: number;
  additionalCompetitors: number[];

  constructor(
    id = null,
    // tslint:disable-next-line:variable-name
    number = 0,
    driver = 0,
    navigator = 0,
    additionalCompetitors = [],
  ) {
    this.id = id;
    this.number = number;
    this.driver = driver;
    this.navigator = navigator;
    this.additionalCompetitors = additionalCompetitors;
  }
}

export class CrewSample {
  id: number;
  number: number;
  driver: CompetitorSimple;
  navigator: CompetitorSimple;
  additionalCompetitors: CompetitorSimple[];

  constructor(
    id = null,
    // tslint:disable-next-line:variable-name
    number = 0,
    driver = null,
    navigator = null,
    additionalCompetitors = [],
  ) {
    this.id = id;
    this.number = number;
    this.driver = driver;
    this.navigator = navigator;
    this.additionalCompetitors = additionalCompetitors;
  }
}
